import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline, Box, useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import ProtectedRoute from "./components/Layout/ProtectedRoute";
import Login from "./pages/Login";
import AuditReport from "./pages/audits/AuditReport";
import {
  mainContentBackground,
  mainContentText,
} from "./components/common/ColorTheme";

const App = () => {
  const muiTheme = useTheme();

  useEffect(() => {
    window.parent.postMessage({ type: "CONNECTED" }, "*");
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Box sx={{ display: "flex", minHeight: "100vh", overflowX: "hidden" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,

              transition: muiTheme.transitions.create(["margin", "width"], {
                easing: muiTheme.transitions.easing.sharp,
                duration: muiTheme.transitions.duration.leavingScreen,
              }),
              overflowX: "hidden",
            }}
          >
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                minHeight: "calc(100vh - 64px - 48px)",
                display: "flex",
                flexDirection: "column",
                backgroundColor: mainContentBackground,
                color: mainContentText,
                overflowX: "hidden",
              }}
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<Navigate to="/audits" replace />} />
                  <Route path="/audits" element={<AuditReport />} />
                </Route>
                <Route path="*" element={<div>404 Not Found</div>} />
              </Routes>
              <ToastContainer position="top-right" autoClose={3000} />
            </Box>
          </Box>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
